import moment from "moment";

const state = {
  statistics: {
    likes: [],
    dislikes: [],
    views: []
  },
  statId: null,
};

const mutations = {
  ADD_LIKE_TO_STATS(state, videoId) {
    state.statistics.likes.push({
      videoId,
      time: moment().format("HH:mm")
    });
  },
  ADD_DISLIKE_TO_STATS(state, videoId) {
    state.statistics.dislikes.push({
      videoId,
      time: moment().format("HH:mm")
    });
  },
  ADD_VIEW_TO_STATS(state, videoId) {
    state.statistics.views.push({
      videoId,
      time: moment().format("HH:mm")
    });
  },
  SET_STATS(state, stats) {
    state.statistics = stats;
  },
  SET_STAT_ID(state, id) {
    state.statId = id;
  }
};

const actions = {

  // CLEAR STATS AFTER SUCCESSFUL UPDATE
  updateStatistics({ state, rootState, getters }) {
    const statsRef =
      rootState.Database.db
        .collection("statistics")
        .doc(state.statId)
        .collection("videos")
        .doc(moment().format("YYYY-MM-DD"));
    const b = state.statistics;
    b.playerUpdated = true;
    statsRef.get()
      .then(doc => {
        if (doc.exists) {
          delete b.lastRead;
          statsRef.update(b)
            .catch(console.error);
        } else {
          statsRef.set(b)
            .catch(console.error);
        }
      })
      .catch(console.error);


    const devRef = rootState.Database.db.collection("devices").doc(getters.getPlayer.id);

    // Set the "capital" field of the city 'DC'
    return devRef.update({
      status: moment().format("YYYY-MM-DD HH:mm")
    }).catch(console.error);
  },
  downloadStatistics({ commit }, statsId) {
    commit("SET_STAT_ID", statsId);
    this.state.Database.db
      .collection("statistics")
      .doc(statsId)
      .collection("videos")
      .doc(moment().format("YYYY-MM-DD"))
      .get()
      .then(doc => {
        if (doc.exists) {
          commit("SET_STATS", doc.data());
        } else {
          commit("SET_STATS", {
            playerUpdated: false,
            utcOffset: moment().utcOffset(),
            lastRead: "00:00",
            views: [],
            likes: [],
            dislikes: []
          });
        }
      });
  }
};

const getters = {
  getLikesToday(state) {
    return state.statistics.likes.length;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Stats.js